import { API_URLS } from "../../constants";
import axios from "axios";

export const getPublicLinkByContainer = async (containerNo, companyId, yardId) => {
  try {
    const response = await axios.post(
      `${API_URLS.PUBLIC_REPORT.GET_PUBLIC_LINK_BY_CONTAINER}`,
      {
        container_no: containerNo,
        company_id: companyId,
        yard_id: yardId || null,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching public link by container number:", error);
    throw error;
  }
};

export const getCompanyYardInfo = async (companyId, yardId) => {
  try {
    const response = await axios.post(
      `${API_URLS.PUBLIC_REPORT.GET_COMPANY_YARD_INFO}`,
      {
        company_id: companyId,
        yard_id: yardId || null,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching company yard info:", error);
    throw error;
  }
};